import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Rotulo } from "../../../../core/styles/superficies";

interface ParDadoProps {
    rotulo: string;
    valor?: ReactNode;
    /** Ocupa a linha inteira — para textos longos, como endereço e observação. */
    largo?: boolean;
}

/**
 * Rótulo acima, valor abaixo.
 *
 * Substitui o padrão "Nome: ———— João" alinhado às bordas opostas: com o valor logo abaixo do
 * rótulo, o olho percorre uma coluna só e não precisa cruzar o cartão a cada linha.
 */
export const ParDado = ({ rotulo, valor, largo }: ParDadoProps) => (
    <Box sx={{ minWidth: 0, gridColumn: largo ? "1 / -1" : undefined }}>
        <Rotulo sx={{ display: "block", mb: 0.25 }}>{rotulo}</Rotulo>
        <Typography
            sx={{
                fontSize: "0.875rem",
                lineHeight: 1.45,
                wordBreak: "break-word",
                color: valor ? "text.primary" : "text.disabled",
            }}
        >
            {valor || "—"}
        </Typography>
    </Box>
);
